import { AgTechButtonProps, AgTechButton, AgTechClickEventHandler } from '@agtech/web/components/Buttons/AgTechButtons';
import AgTechViewDialog from '@agtech/web/components/Portals/Dialogs/AgTechViewDialog';
import { useCurrentSale } from '@sales/data/sales/SaleDataStore';
import React from 'react'
import SaleLotModificationGrid from '../components/grid/SaleLotModificationGrid';
import { useLotDataGetSaleLotDataQuery } from '@sales/data/lots/LotDataQueries';
import AgTechTourHelpButton from '@agtech/web/components/App/Tour/AgTechTourHelpButton';
import { LotUpdateViewDialogTourConfig } from './LotUpdateViewDialogTourConfig';

const LotUpdateViewDialog = () => {
    const currentSale = useCurrentSale();

    return (
        <AgTechViewDialog
            structure={{
                header: () => ({
                    header: `Update Lots - ${currentSale.saleName}`,
                    detail: "To modify lots for this sale, update the grid below",
                    settings: {
                        content: {
                            body: () => <AgTechTourHelpButton tourConfig={LotUpdateViewDialogTourConfig} />
                        }
                    }
                }),
                width: "1200px",
            }}
        >
            {() => {
                return (
                    <div id='lot-update-grid' className='row-based stretched p-body container'>
                        <SaleLotModificationGrid />
                    </div>
                )
            }}
        </AgTechViewDialog>
    )
}

LotUpdateViewDialog.Open = (e: AgTechClickEventHandler) => e.dialogs.openDialog({
    dialog: () => <LotUpdateViewDialog />
});

LotUpdateViewDialog.Button = (props: AgTechButtonProps) => {
    let buttonProps: AgTechButtonProps = {
        ...props,
        text: 'Update Lots',
        icon: 'fas fa-edit',
        action: LotUpdateViewDialog.Open
    };

    return <AgTechButton {...buttonProps} />;
}

export default LotUpdateViewDialog;